var _circle, _g, _g2, _g3, _circle2, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 149,
    viewBox: "0 0 138 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 79.0284,
    r: 69,
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6067_28675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.9068 35.491L91.5189 34.8628L88.6339 28.2069C88.1149 26.9953 86.3443 26.9953 85.8253 28.2069L82.9403 34.8778L75.5676 35.491C74.2244 35.5957 73.6749 37.241 74.6976 38.1085L80.2996 42.8649L78.6205 49.9246C78.3152 51.211 79.7348 52.228 80.8949 51.54L87.2296 47.8007L93.5643 51.555C94.7244 52.243 96.144 51.2259 95.8387 49.9396L94.1596 42.8649L99.7616 38.1085C100.784 37.241 100.25 35.5957 98.9068 35.491Z",
    fill: "#FFD700"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6067_28675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0948 28.2682L55.1306 27.9311L53.5825 24.3596C53.304 23.7095 52.3539 23.7095 52.0755 24.3596L50.5274 27.9391L46.5714 28.2682C45.8506 28.3244 45.5557 29.2072 46.1045 29.6727L49.1104 32.2249L48.2095 36.0131C48.0457 36.7033 48.8074 37.249 49.4299 36.8799L52.829 34.8734L56.2281 36.8879C56.8506 37.2571 57.6123 36.7113 57.4485 36.0211L56.5475 32.2249L59.5535 29.6727C60.1023 29.2072 59.8156 28.3244 59.0948 28.2682Z",
    fill: "#FFD700"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6067_28675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.9828 4.61699L86.4601 4.40248L85.475 2.12973C85.2978 1.71603 84.6932 1.71603 84.5159 2.12973L83.5308 4.40759L81.0133 4.61699C80.5547 4.65274 80.367 5.21455 80.7162 5.51077L82.6291 7.1349L82.0558 9.54555C81.9515 9.98478 82.4363 10.3321 82.8324 10.0971L84.9955 8.82031L87.1585 10.1023C87.5547 10.3372 88.0394 9.98989 87.9352 9.55066L87.3618 7.1349L89.2747 5.51077C89.6239 5.21455 89.4415 4.65274 88.9828 4.61699Z",
    fill: "#FFD700"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6067_28675",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 138,
    height: 139
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 79.0284,
    r: 69,
    fill: "#EBEBEB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6067_28675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 64.0284C19.5 61.5432 21.5147 59.5284 24 59.5284H113.048C115.533 59.5284 117.548 61.5432 117.548 64.0284V83.7427C117.548 86.228 115.533 88.2427 113.048 88.2427H24C21.5147 88.2427 19.5 86.228 19.5 83.7427V64.0284Z",
    fill: "white",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8501,
    y: 68.5793,
    width: 26.2672,
    height: 3.18367,
    rx: 1.59184,
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.557,
    y: 68.5793,
    width: 3.2834,
    height: 3.18367,
    rx: 1.59184,
    fill: "#F42E33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8501,
    y: 76.0082,
    width: 54.7233,
    height: 3.18367,
    rx: 1.59184,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 95.7427C19.5 93.2574 21.5147 91.2427 24 91.2427H113.048C115.533 91.2427 117.548 93.2574 117.548 95.7427V115.457C117.548 117.942 115.533 119.957 113.048 119.957H24C21.5147 119.957 19.5 117.942 19.5 115.457V95.7427Z",
    fill: "white",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8501,
    y: 99.2324,
    width: 26.2672,
    height: 3.18367,
    rx: 1.59184,
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8501,
    y: 107.963,
    width: 54.7233,
    height: 3.18367,
    rx: 1.59184,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.557,
    y: 99.2324,
    width: 3.2834,
    height: 3.18367,
    rx: 1.59184,
    fill: "#FFC839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 127.457C19.5 124.972 21.5147 122.957 24 122.957H113.048C115.533 122.957 117.548 124.972 117.548 127.457V147.171C117.548 149.657 115.533 151.671 113.048 151.671H24C21.5147 151.671 19.5 149.657 19.5 147.171V127.457Z",
    fill: "white",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8501,
    y: 130.947,
    width: 26.2672,
    height: 3.18367,
    rx: 1.59184,
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8501,
    y: 139.677,
    width: 54.7233,
    height: 3.18367,
    rx: 1.59184,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.557,
    y: 130.947,
    width: 3.2834,
    height: 3.18367,
    rx: 1.59184,
    fill: "#23C664"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 106.435C85 110.881 85.0227 114.141 85.0536 114.108C85.083 114.076 85.8523 113.038 86.763 111.802C87.6736 110.566 88.441 109.547 88.4681 109.537C88.4953 109.528 89.3186 110.926 90.2976 112.644L92.0776 115.769L93.3894 115.001C94.3286 114.451 94.6937 114.207 94.6745 114.142C94.6598 114.091 93.8807 112.697 92.9431 111.043L91.2385 108.036L94.3388 108.005L97.4391 107.975L91.303 103.389C87.9281 100.866 85.1294 98.7804 85.0835 98.7537C85.013 98.7127 85 99.9099 85 106.435Z",
    fill: "#526775",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5609 104.711C86.5609 109.157 86.5837 112.416 86.6145 112.383C86.644 112.352 87.4132 111.314 88.3239 110.078C89.2346 108.842 90.0019 107.823 90.029 107.813C90.0562 107.804 90.8795 109.202 91.8585 110.92L93.6385 114.044L94.9503 113.277C95.8895 112.727 96.2546 112.483 96.2354 112.417C96.2207 112.367 95.4416 110.972 94.504 109.319L92.7994 106.312L95.8997 106.281L99 106.251L92.8639 101.664C89.4891 99.1419 86.6903 97.0562 86.6444 97.0294C86.5739 96.9884 86.5609 98.1856 86.5609 104.711Z",
    fill: "#526775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6093 112.693C86.5785 112.726 86.5557 109.467 86.5557 105.021C86.5557 98.4956 86.5388 97.7623 86.6093 97.8033C86.6552 97.83 89.4839 99.4518 92.8588 101.974L92.1557 105.021L90.0239 104.622L92.7943 106.622L90.0239 108.123C89.9967 108.132 89.2294 109.152 88.3187 110.388C87.408 111.624 86.6388 112.661 86.6093 112.693Z",
    fill: "#526775"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6067_28675"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.9121,
    y: 21.9697,
    width: 36.6344,
    height: 35.8971,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6067_28675"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 21.0129,
    width: 19.6575,
    height: 19.2619,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6067_28675"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.7407,
    width: 12.5093,
    height: 12.2576,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/emptyList.9c76e6c8ac011b466523d5f0766652da.svg";
export { ForwardRef as ReactComponent };